import { prop } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class PaymentMethod extends Resource {
    
    public override type = 'cases';
    
    @prop()
    public code!: string;

    @prop()        
    public name!: string;    

    @prop()
    public businessBankAccountEnabled: boolean = false;    

}